import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-garage-icon"
};
const _hoisted_1 = {
  width: "21",
  height: "16",
  viewBox: "0 0 21 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_583)"><path opacity="0.4" d="M19.856 3.65625L11.3521 0.113281C11.1685 0.046875 10.9731 0.0078125 10.7778 0C10.5786 0.0078125 10.3833 0.0429688 10.1997 0.113281L1.69971 3.65625C1.14111 3.89062 0.777832 4.43359 0.777832 5.03906V15.5C0.777832 15.7773 1.00049 16 1.27783 16H3.27783C3.55518 16 3.77783 15.7773 3.77783 15.5V7C3.77783 6.44922 4.23486 6 4.79736 6H16.7583C17.3208 6 17.7778 6.44922 17.7778 7V15.5C17.7778 15.7773 18.0005 16 18.2778 16H20.2778C20.5552 16 20.7778 15.7773 20.7778 15.5V5.03906C20.7778 4.43359 20.4146 3.89062 19.856 3.65625Z"></path><path d="M4.77783 9H16.7622L16.7778 7H4.77783V9Z"></path></g><defs><clipPath id="clip0_3154_583"><rect width="20" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitGarageIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitGarageIcon as default
};
//# sourceMappingURL=uikit-garage-icon.vue.es.js.map
